import { useEffect, useState, useContext, useCallback } from "react";
import { Link, Navigate } from "react-router-dom";
import { Button, Table } from "react-bootstrap";
import { BrowserContext } from "./services/BrowserContext";
import UserFormModal from "./molecules/modals/UserFormModal";

const Admin = ({ user }) => {
    const { itemsManipulator } = useContext(BrowserContext);
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingUser, setEditingUser] = useState(null);

    const loadUsers = useCallback(() => {
        itemsManipulator.listUsers((list) => setUsers(list || []));
    }, [itemsManipulator]);

    useEffect(() => {
        if (user && user.is_admin) {
            loadUsers();
        }
    }, [user, loadUsers]);

    // Garde d'accès : utilisateur chargé mais non-admin -> retour au navigateur.
    // (Le contrôle serveur reste l'autorité : chaque action admin vérifie is_admin.)
    if (user && !user.is_admin) {
        return <Navigate to="/root/" replace />;
    }

    const handleCreate = () => { setEditingUser(null); setShowModal(true); };
    const handleEdit = (u) => { setEditingUser(u); setShowModal(true); };
    const handleDelete = (login) => {
        if (window.confirm(`Supprimer l'utilisateur "${login}" ?`)) {
            itemsManipulator.deleteUser(login, loadUsers);
        }
    };
    const handleSaved = () => { setShowModal(false); loadUsers(); };

    return (
        <>
            <nav className="app-header mx-3 mb-3">
                <span className="app-brand">
                    <i className="bi bi-hdd-stack app-brand-icon"></i>
                    <span className="app-brand-name">ClodoDrive</span>
                </span>
                <Link to="/root/" className="app-user-chip">
                    <i className="bi bi-arrow-left"></i>
                    <span className="app-user-name">Retour</span>
                </Link>
            </nav>

            <div className="container pb-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="h4 mb-0"><i className="bi bi-people-fill me-2"></i>Administration — Utilisateurs</h1>
                <Button variant="primary" onClick={handleCreate}>
                    <i className="bi bi-plus-lg me-1"></i>Nouvel utilisateur
                </Button>
            </div>

            <Table striped bordered hover responsive className="bg-white align-middle">
                <thead>
                    <tr>
                        <th>Login</th>
                        <th>Dossiers</th>
                        <th>Serveur Plex</th>
                        <th className="text-center">Admin</th>
                        <th className="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users.length === 0 ? (
                        <tr><td colSpan={5} className="text-center text-muted py-4">Aucun utilisateur</td></tr>
                    ) : users.map(u => (
                        <tr key={u.login}>
                            <td className="fw-medium">{u.login}</td>
                            <td>{(u.folders || []).map(f => f.name).join(', ')}</td>
                            <td>{u.plex_server || ''}</td>
                            <td className="text-center">
                                {Number(u.is_admin) ? <i className="bi bi-check-circle-fill text-success"></i> : ''}
                            </td>
                            <td className="text-end">
                                <Button size="sm" variant="outline-primary" className="me-2" onClick={() => handleEdit(u)}>
                                    <i className="bi bi-pencil"></i>
                                </Button>
                                <Button size="sm" variant="outline-danger" onClick={() => handleDelete(u.login)}>
                                    <i className="bi bi-trash"></i>
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <UserFormModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                editingUser={editingUser}
                onSaved={handleSaved}
            />
            </div>
        </>
    );
};

export default Admin;
